import { usePackage } from "../package-context"
import UpdateParcel from './UpdateParcel'
import ErrorUpdateParcel from './ErrorUpdateParcel'

export default function UpdateParcelDecider() {
    const { isResponseDataNull } = usePackage()
    const RenderUpdateParcel = ({ children }) => isResponseDataNull === false ? children : null
    const RenderErrorUpdateParcel = ({ children }) => isResponseDataNull === true ? children : null

    return (
        <>
            <RenderUpdateParcel> <UpdateParcel /></RenderUpdateParcel>
            <RenderErrorUpdateParcel><ErrorUpdateParcel /></RenderErrorUpdateParcel>
        </>
    )
}